export const LEGAL_INFO_WEBTHEO_ID = 'WEBTHEO';
export const LEGAL_INFO_NDC_ID = 'NDC';
export const LEGAL_INFO_NDCX_ID = 'NDCx';
export const LEGAL_INFO_THEO_ID = 'THEO';
export const LEGAL_INFO_SMS_ID = 'SMS';
export const LEGAL_INFO_EMAIL_ID = 'EMAIL';
export const LEGAL_INFO_MAIL_ID = 'MAIL';
export const LEGAL_INFO_FOSUN_ID = 'FOSUN_PARTNERS';
export const LEGAL_INFO_CGV_ID = 'CGV';
export const HEALTH_REGULATION = 'HEALTH_REGULATION';
